import moment from "moment";

export const parseDate = (date: string | Date) =>
  moment(date).format("MM/DD/YYYY hh:mm A");

export const parseDateToDateString = (date: string | Date) => {
  return moment(date).subtract(5, "hours").format("MM/DD/YYYY");
};

export function formatUtcDateTime(
  dateAsStringOrDate?: string | Date,
  includeMinutes?: boolean
): string {
  if (!dateAsStringOrDate) {
    return "";
  }

  const date = (dateAsStringOrDate instanceof Date) ? dateAsStringOrDate : new Date(dateAsStringOrDate);

  const month = date.getMonth() + 1; // Months are 0-indexed
  const day = date.getDate();
  const year = date.getFullYear();

  let hours = date.getHours();
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format

  if (includeMinutes) {
    return `${month}/${day}/${year} at ${hours}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")} ${period}`;
  }

  return `${month}/${day}/${year} at ${hours} ${period}`;
}

export function formatSeconds(seconds: number): string {
  const days = Math.floor(Math.abs(seconds) / 86400); // 1 day = 86400 seconds
  const hours = Math.floor((Math.abs(seconds) % 86400) / 3600);
  const minutes = Math.floor((Math.abs(seconds) % 3600) / 60);

  const dayText = days === 1 ? "1 day" : `${days} days`;
  const hourText = hours === 1 ? "1 hour" : `${hours} hours`;
  const minuteText = minutes === 1 ? "1 minute" : `${minutes} minutes`;

  // Build the output based on the non-zero components
  const parts: string[] = [];
  if (days >= 1) {
    parts.push(dayText);
  } else {
    if (hours > 0) parts.push(hourText);
    if (minutes > 0) parts.push(minuteText);
  }

  return parts.length > 0 ? parts.join(" ") : "0 minutes";
}

export function calculateSecondsFromUtcNow(
  utcDate: string | Date | moment.Moment,
  defaultValue: number = 0
): number {
  if (!utcDate) {
    return defaultValue;
  }

  let inputMoment;
  if (typeof utcDate === "string") {
    // Try to parse as ISO, fallback to moment's parser
    inputMoment = moment.utc(utcDate, moment.ISO_8601, true);
    if (!inputMoment.isValid()) {
      inputMoment = moment.utc(utcDate);
    }
  } else if (utcDate instanceof Date) {
    inputMoment = moment.utc(utcDate);
  } else if (moment.isMoment && moment.isMoment(utcDate)) {
    inputMoment = utcDate.clone().utc();
  } else {
    return defaultValue;
  }

  if (!inputMoment.isValid()) {
    return defaultValue;
  }

  const now = moment.utc();
  // Difference in seconds, rounded down (can be negative)
  return inputMoment.diff(now, "seconds", true);
}
